export const paymentBenefits = [
    "Refund guarantee",
    "Customer support",
    "Tixu tools access",
    "20+ top AI courses",
    "3 personal challenges"
];

export const curatorBenefits = ["Chat access", "Zoom reviews", "Task check", "Project help"];

export const targetSubsIds1 = ["e67a0ff9-808d-4524-b40d-6b7e999bff0c", "7122dbc8-3676-4ae1-9fd3-501470c443db"];

export const targetSubsIds2 = ["b81a7b2b-0359-4e2a-90b8-6148dec24c67", "6acbb116-12b2-44ce-ab42-bb36a26bfd1f"];

export const targetSubsIds3 = [
    "9efb5f2c-3e20-4f32-8d27-0e059e40e940",
    "7c24ca40-f5b9-45ed-879e-8af610664f77",
    "95800542-9144-48ef-8dbd-f9f0958b4e6d"
];

type SubscriptionInfoItem = {
    priceWithoutSale: number;
    sale: number;
    benefits?: string[];
    image?: string;
};

export const subscriptionInfo: Record<string, SubscriptionInfoItem> = {
    "e67a0ff9-808d-4524-b40d-6b7e999bff0c": {
        priceWithoutSale: 300,
        sale: 50
    },
    "7122dbc8-3676-4ae1-9fd3-501470c443db": {
        priceWithoutSale: 600,
        sale: 100
    },
    "b81a7b2b-0359-4e2a-90b8-6148dec24c67": {
        priceWithoutSale: 39.99,
        sale: 20
    },
    "6acbb116-12b2-44ce-ab42-bb36a26bfd1f": {
        priceWithoutSale: 69.99,
        sale: 30
    }
};

export const baseSubscriptionInfo: SubscriptionInfoItem[] = [
    {
        priceWithoutSale: 150,
        sale: 50,
        benefits: [
            "1 year full Tixu access",
            "Tixu tools access",
            "20+ top AI courses",
            "3 personal challenges",
            "Customer support",
            "Refund guarantee"
        ]
    },
    {
        priceWithoutSale: 350,
        sale: 100,
        benefits: [
            "1 year full Tixu access",
            "Tixu tools access",
            "20+ top AI courses",
            "3 personal challenges",
            "Customer support",
            "Refund guarantee",
            "Chat access",
            "Zoom reviews",
            "Task check",
            "Project help",
            "Personal curator for 1 month"
        ],
        image: "/images/landing/png/landing-curator-icon.png"
    },
    {
        priceWithoutSale: 650,
        sale: 150,
        benefits: [
            "1 year full Tixu access",
            "Refund guarantee",
            "Customer support",
            "Tixu tools access",
            "20+ top AI courses",
            "3 personal challenges",
            "Chat access",
            "Zoom reviews",
            "Task check",
            "Project help",
            "Personal curator for 3 months"
        ],
        image: "/images/landing/png/landing-curator-icon-2.png"
    }
];
